<template>
  <div class="main">
    <span class="main-config">
      <div v-if="!readOnly" class="op">
        <label>{{ $t('operacoes') }} </label>
        <b-form-select
          class=""
          size="sm"
          v-model="operationSelected"
          :options="operations"
        ></b-form-select>
      </div>
      
      <div v-if="!readOnly" class="cr">
        <label>{{ $t('corrente-de-capacidade-instalada') }} </label>
        <b-form-select
          size="sm"
          v-model="currentCapacity"
          @change="changeCurrentCapacity()"
          :options="currents"
        ></b-form-select>
      </div>

      <b-form v-if="operationSelected && currentCapacity" class="b-layout">
        <b-card class="equip">
          <div v-for="(prop, index) in equipments" :key="prop.value + index">
            <b-form-checkbox
              class="switch-item"
              v-model="prop.value"
              @change="ChangeOnOff($event, prop)"
              switch
              >
              {{ prop.equipName }}
            </b-form-checkbox>
          </div>
        </b-card>

        <div class="attr-list">
          <div class="inp">
            <label>{{ $t('capacidade-instalada-ton-h') }}</label>
            <b-input
              :disabled="disabledCapacity"
              class="inp-number input-pentagro"
              type="number"
              size="sm"
              v-model.number="CapacidadeValue.value"
            ></b-input>
          </div>

          <div class="inp">
            <label>{{ $t('temperatura-de-saida-do-vapor-oc') }}</label>
            <b-input
              class="inp-number input-pentagro"
              type="number"
              size="sm"
              v-model.number="TSaidaVapor.value"
            ></b-input>
          </div>

          <div class="inp">
            <label>{{ $t('temperatura-de-gases-de-escape-oc') }}</label>
            <b-input
              class="inp-number input-pentagro"
              type="number"
              size="sm"
              v-model.number="Ts.value"
            ></b-input>
          </div>

          <div class="inp">
            <label>{{ $t('pressao-interna-bar') }}</label>
            <b-input
              class="inp-number input-pentagro"
              type="number"
              size="sm"
              v-model.number="Pinterna.value"
            ></b-input>
          </div>

          <div 
            v-if="PCSBagaco"
            class="inp">
            <label>{{ $t('pcs-bagaco-base-seca-kj-kg') }}</label>
            <b-input
              class="inp-number input-pentagro"
              type="number"
              size="sm"
              v-model.number="PCSBagaco.value"
            ></b-input>
          </div>

          <div 
            v-if="PCSBagaco"
            class="inp">
            <label>{{ $t('pcs-palha-base-seca-kj-kg') }}</label>
            <b-input
              class="inp-number input-pentagro"
              type="number"
              size="sm"
              v-model.number="PCSPalha.value"
            ></b-input>
          </div>

          <div 
            v-if="consumoCombustivel"
            class="inp">
            <label>{{ $t('prod-esp-de-vapor-kgvap-kgbag') }}</label>
            <p>{{ consumoCombustivel.value | ParseNumber }}</p>
          </div>

          <div 
            v-if="eficienciaPCS"
            class="inp">
            <label>{{ $t('eficiencia-pcs') }}</label>
            <p>{{ eficienciaPCS.value | ParseNumber }}</p>
          </div>

          <div 
            v-if="eficienciaPCI"
            class="inp">
            <label>{{ $t('eficiencia-pci') }}</label>
            <p>{{ eficienciaPCI.value | ParseNumber }}</p>
          </div>

          <div 
            v-if="PCS_Combustivel"
            class="inp">
            <label>{{ $t('pcs-combustivel-base-umida-kj-kg') }}</label>
            <p>{{ PCS_Combustivel.value | ParseNumber }}</p>
          </div>

          <div 
            v-if="PCI_Combustivel"
            class="inp">
            <label>{{ $t('pci-combustivel-kj-kg') }}</label>
            <p>{{ PCI_Combustivel.value | ParseNumber }}</p>
          </div>

          <div 
            v-if="Ocupacao"
            class="inp">
            <label>{{ $t('ocupacao-0') }}</label>
            <p>{{ Ocupacao.value | ParseNumber }}</p>
          </div>
        </div>
      </b-form>
    </span>
    <div v-if="jokerEquipmentList.length" class="joker">
      <label class="mt-2 jockerTitle">{{ $t('equipamentos-coringas') }}</label>
      <div v-for="(joker, i) in jokerEquipmentList" :key="i">
        <b-form>
          <div class="ml-2 mr-2">
            <TextToInput 
              :text="joker.caption"
              @sendText="updateCaption($event, joker)">
            </TextToInput>
          </div>
          <span class="jocker-layout">
            <b-card v-if="equipments.length > 0">
              <div v-for="(prop, index) in joker.equipments" :key="prop + index">
                <b-form-checkbox
                  class="switch-item" 
                  v-model="prop.value"
                  @change="ChangeOnOffJoker($event, prop, equipments, joker)"
                  switch
                  >
                  {{ prop.equipName }}
                </b-form-checkbox>
              </div>
            </b-card>
            <div class="ml-3" v-if="equipments.length > 0">
              <b-card>
                <div class="inp mb-2">
                  <label>{{ $t('capacidade-instalada-ton-h') }} </label>
                  <label class="input-data" >{{ joker.capacidade.value | ParseNumber }}</label>
                </div>
                <div class="inp">
                  <label>{{ $t('ocupacao-0') }} </label>
                  <label class="input-data">{{ joker.Ocupacao.value | ParseNumber }}</label>
                </div>
              </b-card>
            </div>
          </span>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
import { SingletonEnginnering } from "../_service/singletonEngineering";
import { ParseToNumber } from "../../utils/tools";
import { JokerEquipmentMixin } from '../../../mixins/jokerEquipmentsMixin'
import { FiltersMixin } from '../../../mixins/filtersMixin'
import TextToInput from "../../../template/TextToInput"
import { SingletonInter } from '../_service/singletonInter';

export default {
  props: {
    node: {
      type: Object,
      default: null,
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },

  components: { TextToInput },

  mixins: [ JokerEquipmentMixin, FiltersMixin ],

  data() {
    return {
      disabledCapacity: false,
      CapacidadeInstalada: {},
      CapacidadeValue: {},
      TSaidaVapor: {},
      Ts: {},
      Pinterna: {},
      PCSBagaco: {},
      PCSPalha: {},
      consumoCombustivel: {},
      eficienciaPCS: {},
      eficienciaPCI: {},
      PCS_Combustivel: {},
      PCI_Combustivel: {},
      Ocupacao: {},
      CapacityAux: {},
      operations: [{ value: null, text: SingletonInter.$t('selecione-uma-caldeira') }],
      operationSelected: null,
      currents: [{ value: null, text: SingletonInter.$t('selecione-uma-corrente') }],
      current: null,
      currentCapacity: null,
      operationAttributeList: [],
      attributesList: SingletonInter.$t('selecione-uma-caldeira'),
      firstLoad: false,
      equipments: [],
      equipCap: [],
      caldeiras: [],
      tempAr: 0,
      attrList: [
        "CapacidadeInstalada",
        "TSaidaVapor",
        "Ts",
        "Pinterna",
        "PCSBagaco",
        "PCSPalha",
        "consumoCombustivel",
        "eficienciaPCS",
        "eficienciaPCI",
        "PCS_Combustivel",
        "PCI_Combustivel",
        "Ocupacao",
      ],
    };
  },

  watch: {
    operationSelected() {
      if (this.firstLoad) {
        this.firstLoad = false;
        return;
      }

      this.loadEquipments();

      this.operationAttributeList = SingletonEnginnering.getOperationsProperties(this.operationSelected)
        .filter((operation) => 
        this.attrList.includes(operation.key));

      this.attrList.forEach((attr) => {
        this[attr] = this.operationAttributeList.find((p) => attr == p.caption);
        if (this[attr]) this[attr].value = ParseToNumber(this[attr].value);
      });

      this.jokerEquipmentList = [];
      this.updateNode();
    },

    current(value) {
      if (value) this.node.CurrentTempAr = value;
    },

    currentCapacity(value) {
      if (value) this.node.currentCapacityAux = value;
    },

    "CapacidadeValue.value"(value){
      console.log('value :>> ', value);

      if (value > ParseToNumber(this.equipCap[0].value)) {
        this.CapacityAux.value = ParseToNumber(this.equipCap[0].value)
        this.CapacidadeValue.value = this.CapacityAux.value
        //value = this.CapacityAux.value
        console.log('this.CapacidadeValue :>> ', this.CapacidadeValue.value);
        return
      }

      if (value < 0) {
        this.CapacityAux.value = 0
        this.CapacidadeValue.value = 0
        return
      }
      this.CapacityAux.value = value

      this.updateNode();
    },

    "TSaidaVapor.value"() {
      this.updateNode();
    },

    "Ts.value"() {
      this.updateNode();
    },

    "Pinterna.value"() {
      this.updateNode();
    },

    "PCSBagaco.value"() {
      this.updateNode();
    },

    "PCSPalha.value"() {
      this.updateNode();
    },
  },

  methods: {
    loadNode() {
        if (this.node.data[0].index) {
        this.operationSelected = this.node.data[0].index;
        this.buildJokerEquipment(this.node.data[0].index, this.node.jokerCaption)
        this.firstLoad = true;

        if (this.node.CurrentTempAr) {
          this.current = this.node.CurrentTempAr;
          this.changeCurrent();
        }
        
        if(this.node.currentCapacityAux){
          this.currentCapacity = this.node.currentCapacityAux;
          this.changeCurrentCapacity();
        }

        this.node.data.forEach(d => {
          if(d.index == this.node.currentCapacityAux){
            this.CapacityAux = d
            this.CapacidadeValue.value = ParseToNumber(d.value)
          }
        })

        this.loadNotInput();
      }

      this.equipments = new Array();
      
      this.node.data.forEach((p) => {
        if (this.attrList.includes(p.caption)) {
          p.value = ParseToNumber(p.value);
          this[p.caption] = p;
        }

        if (p.index == this.currentCapacityAux) {
          this.CapacityAux = p
          this.CapacityAux.value = ParseToNumber(p.value)
        }
        
        if (p.equipName) {
          let result = ParseToNumber(p.value) ? true : false;
          p.value = result;
          // this.ChangeCapacity(p.value)
          this.equipments.push(p);
        }
      });
      this.loadEquipments();
    },

    loadNotInput() {
      this.operationAttributeList =
        SingletonEnginnering.getOperationsProperties(
          this.operationSelected
        ).filter((operation) => this.attrList.includes(operation.key));
      let attrNotInput = this.attrList.slice(2);

      attrNotInput.forEach((attrName) => {
        this[attrName] = this.operationAttributeList.find(
          (p) => attrName == p.caption
        );
        if (this[attrName])
          this[attrName].value = ParseToNumber(this[attrName].value);
      });
    },

    loadEquipments() {
      let equipsName = SingletonEnginnering.getOperationsEquipments(
        this.operationSelected
      );
      let propsByEquipment = SingletonEnginnering.getEquipamentsProperties(
        this.operationSelected
      );
      let auxEquipment = new Array();

      equipsName.forEach((e) => {
        let props = propsByEquipment[e];
        Object.keys(props).forEach((p) => {
          if (props[p].caption == "Status") {
            props[p].value = parseInt(props[p].value) ? true : false;
            auxEquipment.push(props[p]);
          }

          if (props[p].caption == "Capacidade") {
            this.equipCap.push(props[p]);
          }
        });
      });

      if (!this.firstLoad) this.equipments = auxEquipment;
    },

    updateNode() {
      let attrs = [];

      let addProp = (prop) => {
        if(prop.key)
          attrs.push(prop.clone())
      }

      addProp(this.TSaidaVapor);
      addProp(this.CapacityAux);
      addProp(this.Ts);
      addProp(this.Pinterna);
      addProp(this.PCSBagaco);
      addProp(this.PCSPalha);
      
      this.equipments.forEach((e) => {
        let prop = e.clone();
        prop.value = e.value ? '1,00' : '0,00' ;
        attrs.push(prop);
      });
      this.node.attrs = attrs;
      this.updateJokerNode(this.node, this.jokerEquipmentList)
    },

    loadOperation() {
      let opList = SingletonEnginnering.operations.filter((o) => o.match(/Caldeira/) );
      this.operations.splice(1);
      opList.forEach((op) => this.operations.push({ value: op, text: op }));
    },

    loadCurrents() {
      let crList = SingletonEnginnering.currents;
      this.currents.splice(1);
      crList.forEach((cr) => this.currents.push({ value: cr, text: cr }));
    },

    ChangeCapacity(status) {
      if (status) {
        this.CapacidadeInstalada.value = ParseToNumber(this.equipCap[0].value);
        this.CapacityAux.value = ParseToNumber(this.equipCap[0].value);
        this.disabledCapacity = false
      }
      else {
        this.CapacidadeInstalada.value = 0;
        this.CapacityAux.value = 0;
        this.disabledCapacity = true
      }
    },

    changeCurrent() {
      // let attrs = SingletonEnginnering.getCurrentProperties(this.current);

      // let props = SingletonEnginnering.getCurrentPropertiesAttributes(
      //   this.current,
      //   attrs[0]
      // );
      // props.forEach((p) => {
      //   if (p.key == "T") this.tempAr = p.value;
      // });
    },

    changeCurrentCapacity() {
      let attrs = SingletonEnginnering.getCurrentProperties(this.currentCapacity);

      let props = SingletonEnginnering.getCurrentPropertiesAttributes(
        this.currentCapacity,
        attrs[0]
      );
      props.forEach((p) => {
        if (p.key == "W") {
          this.CapacityAux = p
          this.CapacidadeInstalada.value =  ParseToNumber(p.value);
          this.CapacidadeValue.value = ParseToNumber(p.value)
        } 
      });
    },

    ChangeOnOff(event, prop) {
      prop.value = event;
      this.ChangeCapacity(event);
      this.switchStatusJoker(prop, this.equipments, false, this.ChangeCapacity)
      this.updateNode();
    },
  },

  mounted() {
    this.loadOperation();
    this.loadCurrents();
    this.loadNode();
    this.ChangeCapacity();
    this.changeExternalCapacity = function () { this.ChangeCapacity() }
    this.updataNodeInMixin = function () { this.updateNode()}
  },
};
</script>

<style scoped>

.main{
  display: flex;  
}

.main-config{
  width: 720px;
}

.select{
  height: 32.97;
}

.width-155{
  width: 155px;
}

.input-data{
  width: 70px;
  text-align: right;
}

form {
  margin-top: 10px;
  color: #0009;
  width: 720px;
}

.b-layout {
  display: flex;
  justify-content: space-around;
}

.joker {
  width: 520px;
}

.jocker-layout{
  display: flex;  
}

.jockerTitle{
  padding-left: 10px;
}

.attr-list {
  width: 460px;
}

/* .card {
  margin: 10px;
} */

input {
  width: 150px;
  text-align: right;
}

.inp {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1px 0px;
  height: 32.98px;
  margin-left: -10px;
}

.op,

.cr {
  height: 60px;
  margin-top: 2px;
  margin-left: 2%;
  margin-right: 2%;
}

.equip {
  width: 190px;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

</style>